'use client';

import { useLocaleLink, useTranslations } from '@fshr/context/i18n-context';
import { getConfig } from '@fshr/shared-react';
import Link from '../link';

export default function EmptyItineraryComponent({ bookNowUrl }: { bookNowUrl?: string }) {
	const t = useTranslations();
	const localeLink = useLocaleLink();
	const { STATIC_SITE_URL } = getConfig();

	return (
		<main
			className="grid items-center justify-center spacing-stack-xl py-[80px] px-[60px]"
			aria-labelledby="empty-state-title"
		>
			<h2 id="empty-state-title" className="text-h4 text-black text-center">
				{t('You don’t seem to have any upcoming stays. Would you like to add one?')}
			</h2>
			<div className="flex flex-row items-center justify-center">
				<div className="flex flex-col items-center justify-center spacing-stack-m">
					<Link
						href={
							bookNowUrl
								? `${STATIC_SITE_URL}${bookNowUrl}`
								: `${STATIC_SITE_URL}${localeLink('/find_a_hotel_or_resort/')}`
						}
						intent="filled"
						size="small"
						className="w-full"
					>
						{t('Book now')}
					</Link>
				</div>
			</div>
		</main>
	);
}
